var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { AppBootstrapComponent } from "./components/AppBootstrapComponent";
import { ERoute } from "./helpers/Routes";
import { AdminCheckoutPage } from "./components/CheckoutPage/AdminCheckoutPage";
import { CartPage } from "./components/Cart";
import { AdminSuccessPage } from "./components/Success/AdminSuccessPage";
import { AdminSettings } from "./components/AdminSettings";
var WsAdminRouter = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: "/" },
                React.createElement(Redirect, { to: ERoute.BOOKCART })),
            React.createElement(Route, { path: ERoute.BOOKCART },
                React.createElement(CartPage, __assign({}, props))),
            React.createElement(Route, { path: ERoute.CHECKOUT },
                React.createElement(AdminCheckoutPage, __assign({}, props))),
            React.createElement(Route, { path: ERoute.SUCCESS },
                React.createElement(AdminSuccessPage, null))),
        React.createElement(AdminSettings, __assign({}, props))));
};
export var AdminRouter = function (props) { return (React.createElement(AppBootstrapComponent, __assign({}, props, { Component: WsAdminRouter }))); };
